export default Object.freeze( {
  EXERCISE: 1,
  PREPARATION: 2,
  EVALUATION: 3
})
